/**
 * Application Component — компонент прикладного слоя.
 */
import DefaultElementNodeType from '../DefaultElementNodeType';
import {APPLICATION_COMPONENT} from '../../metamodel/Concept';

export default class ApplicationComponentNodeType extends DefaultElementNodeType {
	static get typeName() {
		return APPLICATION_COMPONENT;
	}
}
